import React, { useState } from "react";
import orgFavlogoRed from "../../../Assets/orgFavRed.svg";
import orgFavLogoGrey from "../../../Assets/orgFavGrey.svg";
import peopleFavlogoGrey from "../../../Assets/peopleFavGrey.svg";
import peopleFavlogoRed from "../../../Assets/peopleFavRed.svg";
import FavListFolderGrey from "../../../Assets/FavListFolderGrey.svg";
import FavListFolderRed from "../../../Assets/FavListFolderRed.svg";
import FavListPeopleGrey from "../../../Assets/FavListPeopleGrey.svg";
import FavListPeopleRed from "../../../Assets/FavListPeopleRed.svg";
import "../FavoritesListSearch/FavoriteListSearch.css";
import { InputBase, Paper } from "@mui/material";
import { APIUrlThree, APIUrlToken } from "../../../Utils/Utils";
import axios from "axios";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import CloseIcon from "@mui/icons-material/Close";
import Loader from "../../Loader/Loader";
import {
  AI_PROFILE_FORM_TABLE,
  AI_PROSPECT_PROFILE,
  COMPANY_PROFILE_SCREEN,
} from "../../../Utils/Constants";
const FavoriteSearch = ({
  activeList,
  setActiveList,
  activeSearch,
  setActiveSearch,
  setLoading,
  loading,
  setSearchResultOrganization,
  setSearchResultPeople,
  setFavoriteSearchData,
  searchResultOrganization,
  searchResultPeople,
  setRetrieveData,
  setheaderSearchData,
  setheaderSearchDataPeople,
}) => {
  const [showSearchdata, setshowSearchdata] = React.useState(false);
  // const [headerSearchData, setheaderSearchData] = React.useState("");
  const [responseData, setResponseData] = React.useState(null);

  const [searchTabs, setSearchTabs] = React.useState("org");
  const navigate = useNavigate();
  const emtySearchdata = () => {
    setheaderSearchData("");
  };
  React.useEffect(() => {
    const handleClick = (event) => {
      if (event.target.closest(".multi_search_header")) {
        return;
      }
      setshowSearchdata(false);
    };
    document.addEventListener("click", handleClick);
    return () => {
      document.removeEventListener("click", handleClick);
    };
  }, []);
  // const handleOrganizationsearch = () => {
  //   setLoading(true);
  //   const option = {
  //     method: "POST",
  //     headers: {
  //       "access-control-allow-origin": "*",
  //       "X-API-Key": APIUrlToken(),
  //     },
  //     url: `${APIUrlThree()}/v1/search_favourites_org?search_term=${headerSearchData}&skip=0&limit=100`,
  //   };
  //   axios(option)
  //     .then((response) => {
  //       if (response.status === 200) {
  //         setLoading(false);
  //         setshowSearchdata(true);
  //         const sortedOrgData = response?.data.org?.sort((a, b) =>
  //           a.name.toLowerCase().localeCompare(b.name.toLowerCase())
  //         );
  //         setResponseData(sortedOrgData);
  //         setFavoriteSearchData(sortedOrgData);
  //         // setShowSearchdata(false)
  //       }
  //     })
  //     .catch((error) => {
  //       setLoading(false);
  //       toast.error(error.response?.data?.message);
  //     });
  // };
  // const handlePeoplesearch = () => {
  //   setLoading(true);
  //   const option = {
  //     method: "POST",
  //     headers: {
  //       "access-control-allow-origin": "*",
  //       "X-API-Key": APIUrlToken(),
  //     },
  //     url: `${APIUrlThree()}/v1/search_favourites_people?search_term=${headerSearchData}&skip=0&limit=100`,
  //   };
  //   axios(option)
  //     .then((response) => {
  //       if (response.status === 200) {
  //         // setSearchResultPeople(true);
  //         // setSearchResultOrganization(false);
  //         setLoading(false);
  //         setshowSearchdata(true);
  //         const sortedOrgData = response?.data?.people.sort((a, b) =>
  //           a.first_name.toLowerCase().localeCompare(b.first_name.toLowerCase())
  //         );
  //         setResponseData(sortedOrgData);
  //         setFavoriteSearchData(sortedOrgData);
  //       }
  //     })
  //     .catch((error) => {
  //       setLoading(false);
  //       toast.error(error.response?.data?.message);
  //     });
  // };
  // React.useEffect(() => {
  //   let timer;
  //   if (headerSearchData?.length > 2) {
  //     timer = setTimeout(() => {
  //       if (activeSearch === "organization") {
  //         handleOrganizationsearch();
  //       } else {
  //         handlePeoplesearch();
  //       }
  //     }, 1000);
  //   }
  //   return () => clearTimeout(timer);
  // }, [headerSearchData, activeSearch]);
  // const handleKeyDown = (event) => {
  //   if (event.key === "Enter") {
  //     setshowSearchdata(false);
  //     if (activeSearch === "organization") {
  //       setSearchResultPeople(false);
  //       setSearchResultOrganization(true);
  //     } else if (activeSearch === "people") {
  //       setSearchResultPeople(true);
  //       setSearchResultOrganization(false);
  //     } else {
  //       setSearchResultPeople(false);
  //       setSearchResultOrganization(false);
  //     }
  //   }
  // };
  // const handelselectdata = (item) => {
  //   setheaderSearchData(item?.name);
  //   if (searchTabs === "org") {
  //     navigate(`/companyprofilescreen/${item?.org_id}/0`, {
  //       state: {
  //         isComponyScreen: window.location.pathname.includes(
  //           "companyprofilescreen"
  //         ),
  //       },
  //     });
  //   } else {
  //     navigate(`/Profile/${item?.person_id == 0 ? "0" : item?.person_id}`);
  //   }
  // };
  // const handleOnchange = (e) => {
  //   const inputValue = e.target.value;
  //   setheaderSearchData(inputValue);
  //   if (e.target.value == "") {
  //     setRetrieveData(true)
  //   }
  // }

  const [isMobile, setIsMobile] = React.useState(window.innerWidth < 768);
  React.useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div className="searchbox-favrite-list">
      {" "}
      {loading ? <Loader /> : null}
      <div className="fav-list-heading">
        <h3>Favorites</h3>
        {isMobile ? (
          <div className="mylist-shared-list-section">
            <div
              className={
                activeList === "myList"
                  ? "img-my-list-text-red"
                  : "img-my-list-text"
              }
              onClick={() => {
                setSearchResultOrganization(false);
                setSearchResultPeople(false);
                setActiveList("myList");
                setheaderSearchData("");
                setheaderSearchDataPeople("");
              }}
            >
              <p> My Lists</p>
            </div>
            <div
              className={
                activeList === "sharedList"
                  ? "img-my-list-text-red"
                  : "img-my-list-text"
              }
              onClick={() => {
                setSearchResultOrganization(false);
                setSearchResultPeople(false);
                setActiveList("sharedList");
                setheaderSearchData("");
                setheaderSearchDataPeople("");
              }}
            >
              <p>Shared Lists</p>
            </div>
          </div>
        ) : (
          <div className="mylist-shared-list-section">
            <div
              className={
                activeList === "myList"
                  ? "img-my-list-text-red"
                  : "img-my-list-text"
              }
              onClick={() => {
                setSearchResultOrganization(false);
                setSearchResultPeople(false);
                setActiveList("myList");
                setheaderSearchData("");
                setheaderSearchDataPeople("");
              }}
            >
              <img
                src={
                  activeList === "myList" ? FavListFolderRed : FavListFolderGrey
                }
                alt="My Lists"
              />{" "}
              <p> My Lists</p>
            </div>
            <div
              className={
                activeList === "sharedList"
                  ? "img-my-list-text-red"
                  : "img-my-list-text"
              }
              onClick={() => {
                setSearchResultOrganization(false);
                setSearchResultPeople(false);
                setActiveList("sharedList");
                setheaderSearchData("");
                setheaderSearchDataPeople("");
              }}
            >
              <img
                src={
                  activeList === "sharedList"
                    ? FavListPeopleRed
                    : FavListPeopleGrey
                }
                alt="Shared Lists"
              />{" "}
              <p>Shared Lists</p>
            </div>
          </div>
        )}
      </div>
      {/* <div>
        <p className="fav-list-search-head">Favorite List Search:</p>
        <Paper>
          <InputBase
            value={headerSearchData}
            onChange={(e) => {
              handleOnchange(e)
            }}
            className="fav-type-input"
            onKeyDown={handleKeyDown}
            sx={{ ml: 1, flex: 1 }}
            placeholder=""
            inputProps={{ "aria-label": "Search google maps" }}
            autocomplete="off"
          />
          <div onClick={emtySearchdata} className="cross-icon-prospect-search">
          </div>{" "}
          {showSearchdata && (
            <div
              className={
                window.location.pathname === COMPANY_PROFILE_SCREEN ||
                window.location.pathname === AI_PROFILE_FORM_TABLE ||
                window.location.pathname === AI_PROSPECT_PROFILE
                  ? "NewClassNamepathname"
                  : "Autocompletedropdown-fav"
              }
            >
              {responseData?.length > 0 ? (
                responseData.map((item, index) => (
                  <>
                    {item?.id === null ? (
                      <div
                        className="outterAutocompletedropdown2"
                        key={`heading-${index}`}
                      >
                        <div className="useralldata">
                          <strong>
                            {searchResultPeople ? item?.first_name : item?.name}
                          </strong>
                        </div>
                        <div className="separatorline"></div>
                      </div>
                    ) : (
                      <div
                        className="outterAutocompletedropdown"
                        key={item.id || `data-${index}`}
                      >
                        <div
                          onClick={() => handelselectdata(item)}
                          className="useralldata"
                        >
                          {[
                            searchResultPeople
                              ? item?.name
                              : item?.name?.toLowerCase() === "jp nauseef"
                              ? "JP Nauseef"
                              : item?.name
                                  ?.split(" ")
                                  .map(
                                    (word) =>
                                      word.charAt(0).toUpperCase() +
                                      word.slice(1).toLowerCase()
                                  )
                                  .join(" "),
                            item?.primary_organization
                              ?.split(" ")
                              .map(
                                (word) =>
                                  word.charAt(0).toUpperCase() +
                                  word.slice(1).toLowerCase()
                              )
                              .join(" "),
                            item?.primary_job_title
                              ?.split(" ")
                              .map(
                                (word) =>
                                  word.charAt(0).toUpperCase() +
                                  word.slice(1).toLowerCase()
                              )
                              .join(" "),
                            item?.linkedin,
                          ]
                            .filter(Boolean)
                            .join(", ")}
                        </div>
                        <div className="separatorline"></div>
                      </div>
                    )}
                  </>
                ))
              ) : (
                <div className="useralldata">Not Available</div>
              )}
            </div>
          )}
        </Paper>
        <div className="mylist-shared-list-section">
          <div
            className={
              activeSearch === "organization"
                ? "org-people-toggle-red"
                : "org-people-toggle"
            }
            onClick={() => {
              // setSearchResultOrganization(false)
              // setSearchResultPeople(false)
              setActiveSearch("organization");
            }}
          >
            <img
              src={
                activeSearch === "organization" ? orgFavlogoRed : orgFavLogoGrey
              }
              alt="My Lists"
            />{" "}
            <p>Organization</p>
          </div>
          <div
            className={
              activeSearch === "people"
                ? "org-people-toggle-red"
                : "org-people-toggle"
            }
            onClick={() => {
              // setSearchResultOrganization(false)
              // setSearchResultPeople(false)
              setActiveSearch("people");
            }}
          >
            <img
              src={
                activeSearch === "people" ? peopleFavlogoRed : peopleFavlogoGrey
              }
              alt="Shared Lists"
            />{" "}
            <p>People</p>
          </div>
        </div>
      </div> */}
    </div>
  );
};
export default FavoriteSearch;
